import React, { Component } from 'react';
import '../../stylesheet/carddesign.css'
// import logo from "../../images/IChooselogoNew.png";
// import chiplogo from "../../images/gmcab-chip-logo.png"
// import prepaidvisa from "../../images/visa1.png"
// import wave from "../../images/whitevisa.png";
// import Background from '../../images/MyRewards-Background.png'
import { connect } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import Loader from '../loader/loader.jsx';
import service from "../../services/allservices.jsx";
import { toast, ToastContainer } from "react-toastify";
import { HighlightSharp } from '@material-ui/icons';
import eyeicon from "../../images/eyeicon.png"
import { getClientId, getClientSecret, buildClientHeader } from '../../utils/clientAuth.js';

const mapStateToProps = state =>
({

  cardImageState: state.getCardImageReducer.cardImageState,

})
const mapDispatchToProps = dispatch =>
({

  fetchCardImage(programId) {
    dispatch(
      actions.getCardImageAction(programId)
    )
  },
  clearCardImage() {
    dispatch(actions.clearCardImageAction())
  }

})
var timer;

class CardDesign extends Component {

  constructor(props) {
    super(props);
    this.state = {
      cardWidget: "",
      oldkitNo: "",
      showDigitalCard: false,
      loader: false,
    };
  }

  componentDidMount() {
    const { cardImage } = this.props

    // 
    this.props.fetchCardImage(cardImage)
    this.setState({
      oldkitNo: this.props.kitNo,
    })
    // if(this.props.provisionDigitalWallet === true && this.props.cardStatus === "Unlocked"){
    //     this.fetchCardWidget();
    // }
    // setTimeout(function () {
    //     let ele = document.getElementById("firstDiv")
    //     ele.classList.remove("layoutopac")
    // }, 2000)
  }
  componentWillUnmount() {
    this.props.clearCardImage()
  }
  componentWillMount() {
    this.props.clearCardImage()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.kitNo !== this.props.kitNo) {
      console.log("Clear timer")
      window.clearTimeout(timer);
      this.setState({
        showDigitalCard: false
      })

    }

  }





  formatNumber(cardno) {


    if (!cardno || cardno === 'undefined' || cardno === 'null') return '';
    const value = cardno.toString();

    let arr = []
    for (let i = 1; i <= value.length; i++) {
      arr.push(value[i - 1])
      if ((i % 4) === 0) { arr.push(' ') }
    }
    return arr.join('')
  }

  fetchCardWidget = () => {
    this.setState({
      loader: true
    })
    let state = {
      kitNumber: this.props.kitNo,
      applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
    };

    console.log("WidgetData", this.state)

    let token = "Token " + localStorage.getItem("token");
    let plink = localStorage.getItem('pform') === 'AU' ? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ
    let traceId = getClientId();
    console.log("plinkcdw", plink + service.getCardWidget)
    fetch(plink + service.getCardWidget, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: token,
        'X-Trace-Id': traceId,
        'X-Client-APP': buildClientHeader(),

      },
      body: JSON.stringify(state),
    }).then((response) => {
      if (response.status === 200) {
        response.json().then((json) => {
          this.setState({
            cardWidget: json.result,
            loader: false,
          });
        });
      } else if (response.status === 422) {
        toast.error(response.headers.get("message"), {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 60,
        });
        this.setState({
          loader: false
        })
      } else if (response.status === 401) {
        if (this.props.history !== undefined) {
          this.props.history.push("/SessionOut");
        }

        this.setState({
          loader: false
        })
      } else {
        toast.error(response.headers.get("message"), {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 60,
        });
        this.setState({
          loader: false
        })
      }
    });
  }
  handleShowCard = () => {
    let _this = this
    if (_this.props.provisionDigitalWallet === true) {
      _this.setState({
        showDigitalCard: true,
        loader: true
      })
      _this.fetchCardWidget();
    }

    timer = window.setTimeout(() => {
      _this.setState({
        showDigitalCard: false,
        cardWidget: "",
      })
    }, 60000);

    // _this.setState({
    //     showDigitalCard : true,
    //     loader :true
    //   })
  }
  render() {
    //  const cardState = localStorage.getItem("cardState")
    //  console.log(cardstate)

    const { name, cardno, balance, cardImageState, provisionDigitalWallet, cardStatus, showView } = this.props
    console.log("Props ", this.props)
    console.log("Props cardImageState", cardImageState)
    console.log("showDigitalCard", this.state.showDigitalCard)
    console.log("Card Widget", this.state.cardWidget)
    console.log("Card Type")
    //  const cardStateType = JSON.parse(localStorage.getItem("cardState"))?.body?.[0]?.typeOfCard
    const cardData = JSON.parse(localStorage.getItem("cardState"));

    const cardStateType = cardData && cardData.body && cardData.body[0] && cardData.body[0].typeOfCard

    return (
      <div>
        <ToastContainer />
        <div>

          {cardImageState && cardImageState.status === 200 && cardImageState.body ? (

            (provisionDigitalWallet === true && this.state.showDigitalCard && cardStatus === 'Unlocked') ? (
              // Show iframe card
              <div
                style={{
                  position: "relative",
                  backgroundColor: "black",
                  //backgroundImage: `url(data:image/${cardImageState.body.cardDesignType};base64,${cardImageState.body.cardDesignContent})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  height: "230px",
                  width: "362px",
                  borderRadius: "16px",
                  border: "1px solid #666",
                }}
              >
                <iframe
                  id="cardIframe"
                  name="cardIframe"
                  src={this.state.cardWidget}
                  style={{
                    position: "absolute",
                    top: -40,
                    left: 2,
                    height: "200%",
                    width: "100%",
                    border: "none",
                    overflow: "hidden",
                    backgroundColor: "transparent",
                    zIndex: 10,
                    scrollbarWidth: "none",
                    msOverflowStyle: "none",
                  }}
                  scrolling="no"
                ></iframe>
              </div>
            ) :
              <div className="carddesign ">
                {/* {cardImageState && cardImageState.status === 200 && cardImageState.body ? */}
                <div className="cardBase" style={{ backgroundImage: `url(${`data:image/`}${cardImageState && cardImageState.body && cardImageState.body.cardDesignType};base64,${cardImageState && cardImageState.body && cardImageState.body.cardDesignContent})`, backgroundRepeat: 'no-repeat', backgroundSize: 'contain', height: '230px', width: '362px', borderRadius: '16px' }}>
                  <div className="bank-name" style={{ padding: "15px 0px 0px 20px" }}>
                    {/* <img src={logo} alt="NZProgram"style={{ height: 45, width: 100 }}  /> */}
                  </div>
                  {/* <div className="chip">
                        <img src={chiplogo} alt="NZProgram" />
                        <img src={wave} alt="NZProgram" />
                    </div> */}
                  <div className="data">
                    <div className="simsfont pan" style={{ color: `${cardImageState.body.textColourOnCard}` }}>{this.formatNumber(cardno)}</div>
                    {(cardStateType !== 'PHYSICAL' && showView==='Y') &&
                      <span className="simsfont viewmore" onClick={this.handleShowCard}>
                        <img src={eyeicon} alt="Click to View Card Details" />
                      </span>
                    }
                    {/* <div className="first-digits">{startwith}</div> */}
                    {/* <div className="exp-date-wrapper">

                            <div className="left-label" style={{ marginLeft: "10px" }}>valid Thru</div>
                            <div className="exp-date">
                                <div className="upper-labels">MONTH/YEAR</div>
                                <div className="date">{balance}</div>
                            </div>
                        </div> */}

                    <div className="row">
                      <div className="col-sm-8 simsfont nopaddingright" style={{ marginTop: "12px", marginLeft: "15px" }}>
                        <div className=" simsfont date" style={{ color: `${cardImageState.body.textColourOnCard}` }}>{balance}</div>
                        <div className=" simsfont name-on-card mt-0" style={{ color: `${cardImageState.body.textColourOnCard}` }}> {name}</div>
                      </div>

                      {/* <div className="col-sm-3 visacard nopadding" >
                                <div className="left-label" style={{ marginTop: "-15px", marginLeft: "15px", fontsize: "15px", fontWeight: "bold" }}>PREPAID</div>
                                <img src={prepaidvisa} alt="VISA" style={{}} />
                            </div> */}
                    </div>

                  </div>
                  {/* <div className="lines-down"></div>
                    <div className="lines-up"></div> */}
                </div>
                {(cardStateType !== 'PHYSICAL' && showView==='Y') &&
                  <span className='mt-2 pt-2'>Click the eye icon above to view your card details.</span>
                }
              </div>
          ) :
            (
              //  <Loader />
              <div> </div>
            )}
        </div>
        {this.state.loader &&
          <Loader />
        }
      </div>
    );
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(CardDesign);


// WEBPACK FOOTER //
// ./src/components/carddesign/carddesign.jsx